export default [
  '/gateway',
  '/common',
]
